// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"3e3d422c","183":"2424ff04"}[chunkId] + ".chunk.js";
};